import React, { useState ,useEffect} from 'react';
import holder from 'holderjs'
import { Button,Row,Card,Col,Container,Image} from 'react-bootstrap';
import '../App.css';
import ReactGa from 'react-ga'
function About(props) {
  useEffect(()=>{
    ReactGa.initialize("UA-179941435-1");
    ReactGa.pageview('/about');
  })
    const [show, setShow] = useState(false);


    return (
        <div className="App" >
          <Container fluid>
          <Row >
          <Col style={{marginTop:"auto" ,marginBottom:"auto"  } }>

  
<h1>אודות</h1> 

      <p>הי לכולם ולסטודנטים של בראודה,
כולם יודעים כמה חשוב לבנות מערכת עם כמה שפחות ימים וכמה שפחות חלונות</p>
      <p>.הנסיון אומר שצריך להשקיע יחסית הרבה זמן ולעשות את זה לא מעט פעמים</p>
  
      <p>
❤️.מקווה שהמערכת תעזור לכם </p>

</Col>
<Col style={{maxWidth:"40%" } }>
         
         <Card  >
           <Card.Img variant="top" src={require('../img/vladi.png').default} />
           <Card.Body>
             <Card.Title>?מי אני </Card.Title>
             <Card.Text>
         ולדיסלב בלאוסוב בוגר מחלקת הנדסת תכנה
             </Card.Text>
           <a  href ="https://www.linkedin.com/in/vladi-belousov/">  <img herf="./" style={{width:"30px"}} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAkFBMVEX///9KdKBLdqFIb55Kc6BHbp1Md6JJcZ9NeaNGbJxKdaBKcqBJcJ9LdaFJcp9IcJ6/y9vL1uLW3ug6ZZjF0N7m7PFbgqmWqsSouMw9bpw8apu0wtU+cJ3y9fg9aJs2Z5nf5u2KpL95lbZpiq+vvtIyX5R8mrmdsMhbf6hvjbGMp8Jph654lrZWeqaFnrujs8pN4LGuAAAKb0lEQVR4nO3da3OiMBQGYFGQIgoVRCUVpFqt9ub//3eL7bprIck5J6CQGd5v7XScPgZyh/R6Xbp06dKlS5cuXbp06dLlLknyZEH9yc4f3LAtCp5e99uHh1Ucr34nvqT4Mz4sz2Qy/1g8BVEjumT6th2uVqP+8GH4UMzwb0q/KKUvyuQc0zCN/Nvx5s+zOyuj5Xy16g/LtHqBeUbnGDmTDU93QyaPH6uRwHYT4A/SiNn26R73ZbR4WInK7qbAPF7sPWe39j0b0uK7KfCcON7c0hjt4z7guzEwj7++nXFpgL7bA89G9nqT+3E6X4G+uwDP1+phVj9wD9Qv9wSe65xjzcUYzKEK5q7A86VqBnUCXwxEAd4VaJg2O9UH3CPuwHsDTdNlx5p8yRZzhd4dmMc61NKRi+ZwG9EM0DT9YVYDkDN0aAswJ9qV65tIOIBoA9DM65uKxHaX4DfRz6oAk3nbged7sUp1s21vJXNF/FQH7tvaTPyOtVUFvrSyoeeEvaoBA0MTYE6cqgBxtUwrgK7tq4w0UDdhO4Cua73TgVPMTdgWoOuyR7IQc422B+iOJ9TrdNmeKQsMMC/EBQ0Y6QZ0vTWtg7pvx6waAej5pMomi7UDerRC/Gp+4pcM9HxC5y0CezMtBHoeYaj41uzahCLQs/ZYYKJlCXr2mGFHik9AU9FSoI2fQf1oan2wItAeHHBAoLVvL9C2kQ3Gsokl7FqANntGCbUtQTuvaypfpELg5GfLzGrUJDC/TDOEcCYRCoATL94uZ0EWzJZb5k2aA9rsCSF8E/fYBEDDuFp1Tl4NozGg7WwQQvHQVwBcbX83tNHcawpo+5/wQFi8UCEClvtKRxHx1sD8Ms1AYSC6DQXAEadHn8yNhoB2Cs/XiLpsolqU+6VN44aANmJyeMFv70VAg9/GfnAK8R7AsfMFCvnzF8J2UDAme1w1Axw78FwGtyoVAvsHft2VsGaA44EJVabcsaEQODRE7c9q0ghwPE5BIec2FAOHhuiy3xrNAMchNApOyrNsEqCooikK7wcchxkgjEpCGXBofAg+ZzhqBjgGh4ilBl8KHE7mgs9hDQH9NbRrsbjkJAcOh3HG/5i4IaAPLkIVhBBwuOJP/jwbDQGpQhCYFyKvds7iSUNAohABHBq8adiN1xSQJsQA80IsX6fPcWNAkhAHzIlvhc/4WDUHpAixwJw4v97s8XhoEuiDA8R/Qjyw3zfi7WsQJb0omy7msdEkcBBihRRg/2zMYQ+GF68aayZ+gGghEfgDGv0aTzQDxAoVgMU0BEQKNQbihDoDUUKtgRjh/YG+xdj6HMYsvyKQIMQCR8XHuM8PbvtXQIP3oLZ3AboDtt6eZt+PpmfB42m7Zr5XAYgQxkTgw7KY0+m0MP8D9+dfFLLcej9Ay98UN79Ov1xmKwPRQvQlanAH+ZFhXi7RmLvetYjPQJ898+aNktPYUgVihfh7UCA0zcstGL+IhCbbiuZUoq/UVgMihYRKRiQ0QKEpXXSfsYESECek1KKiq/QiNERCly2l/0jyaakAUUJSMwEIDZHQAoD5Zxx8BSBGSGsH5UJDKFzDW3oj26cDKUIUUC48twgxt6zeMNtdgzUdSBDigFKhIRGi9tgtUzIQL0QCZUJDIkRuIny3qEC0EAuUCA2ZEJlgTQVihWigWGjUIewdHSIQKcQDxb22eoRTRgTihASgSOjVJOyZPg1IGgFjgDcXnhgNOIDnS2MSsLIwyabnmVZhspAGxI8PkcBqwuTlyPKB/drdiJc1bZ8EtNSFfGAl4WzCvictXNtab0Tl+GWRgOpCAbBvcDePo4Sva+//nIwl2gfzxEhAZaEI2DeVy/DEfk06WYJ99kFIAqoKhcCJqVqGU1aYVWPcQUgvYQMKUFEoBqoLTbs4bSh4CvTTogDVhBKgsvAUl+ZFGb9CfXcoQCWhDKgsnHilid+Yv4Ns41CAKkIpcKJY0wSsPLPt8/c5PjsUoIJQDlQtw0dWnrq3uRtXvoV4IF0IAFXL8IVx1ib4W9IWjAIkCyHgRLFPc7I4axMpt6pZMAqQKgSBI0XhwuIsvvA3ivwTooBEIQwEhSYkvJrZ5j/ScxHigDQhAggJTUh4PXWfyoRIIEmIAQJCExL+WpuQCbFAihAFlAtNSPh78UUiRAMJQhxQKjQhYWF1SSzEA/FCJFAmNCFhcflMKCQA0UIsUCI0IWFpfVAkpACxQjRw5ImEJiQsL4BShTwgUogHGiKhCwk5K7xEIReIExKAIqGNFdrKQj4QJaQAqwptZaEAiBGSgLCQP/3yV2grC0XAKkL+Vq5Kwt9AYb+UAnTUhYK9alWEBSChDMVAdaFoM14FYRGIF0qAykLhbkN1YQk4xgplQFWhEKguLAOxQilQUSgGKgtZGYgUyoFqQgmwNuEYKwSASkIZsC7hGCuEgCpCKbAm4RgrBIEKQjmwHuEYK4SB9D4NAKxFOMYKEUCyEALWIfy3AAr12jBAqhAEgkLBwueV8P8KLyBEAYlCGAgJXVf0b5eBgBAHpAkRQEDogsLrNXqpEAkkCTFAudAFhb82IciEWCBFiAJKhS4o/L3LQiJEAwlCHFAmdEFhYRuJWIgH4lt8JFAidEFhcZ+MUEgAooVYoFjogsLSRiBRi08BYoVooGErC8s7nahCHhApxANNm79TwR5f1gdFC7ucrVwCYUoB4oQEoOkdprNynv4BPWvB+YPpzyaZwjYS9sb5qPxPKUCUkALMiYyXqxVeK/8xLYYHzIkhJzQgRkgD8sLZhMAZ0ZN2OqGBCCHTGwgLA6Y30Amh90RFTG+gE0KH6iRMb6Czg95mlsR6A51dBgn/P4WtJdDZgW8VPJhaAx0HfJHwxtAbCL9a/22lNTCFX3f9EusMdFL4zfrTWGegE/Kf2rhOttIZ6ISI8x8OOgMdG3E42ddKYyDiVdC93mOsMTDEnDQTMX2BqNuw19MY6KQY4M/7fzQFwu+cPyfjXqY6AJ0d8sTVuacp0HFwwLzjpikwxB2GdH5ruakl0AHfx/4v+5WWwPSIBfayWEcgPM12laOnIdBx8cBesNYQuCMU4XUhagNMkUcDXgqR6QZEt/aX/O266QMkVKQ/SYZ6AZ00Iwp7j0wrIGpgWMjW1wiYftKBvcT3tAHCqxXcXN6vogEQMYfIzYJHbCUQfZhzMZxbsY1ApZvwJ8mkSGwj0AGP6ZIkmtgaAPFHqnOSWV7rgcTeWjFT5rUbSBtRcImx3Wog5gBgIIHptxcI7g9CJfquUdsITAVnhJKTzFkrgSHieGNsFlVOK7gVcCd8m6RKZtagZcB0p9gXFSU6MNXTCm4CDD8rdGQEeXF577JoBpiG8NHNCkm+1n4rgOnumN0CmCc4rFVe5l8zcHeo2E+TZrplpefM7wpMQ7dyNw0yblI2aAoYhsdb+87JXj/XVgPANHQW2R183wm+vk+fuiMwDMN9LX1QAvLlaDKWOtbgxsA0DXfO+6mmHigtSfC02Ly7+de7/vsgScp7JCSP6PdQdrv08/j1EtTfupOcSRQEjzfJLIiSOvueXbp06dKlS5cuXbp06dJFmD+AQZKbZk38AQAAAABJRU5ErkJggg==" />
           </a> 
           </Card.Body>
         </Card>
         
         
         </Col>  
 <Col style={{marginTop:"auto" ,marginBottom:"auto" } }> 
<h1>הוראות שימוש</h1> 
<p >הכניסו את קודי הקורסים שברצונכם לשבץ</p>
<p>בחרו את האפיון של המערכת שלכם לפי:ימים,חלונות,מרצים</p>
<p>"לחצו על "בנה מערכת</p>
<p>וואלה יש לכם מערכת לסמסטר הקרוב</p>
</Col>
     
         <Col style={{maxHeight:"5%" } }>
         <img herf="./"  src={require('../img/gif.gif').default}/>
         </Col>
         
        
</Row>

</Container>


        </div>
    );


}
export default About;